import React from 'react';

import { Content } from './Content.js';
import IconListPanelCol from './IconListPanelCol.jsx';
// import { Utils } from './../../utils/Utils.js';

export default class IconListPanel extends React.Component {

  render() {
    var lastClass = (this.props.isLast === true) ? 'last' : '';
    var icons = Content[this.props.page][this.props.section].icons;

    return (
      <div className={`IconListPanel row ${lastClass}`}>
        <div className="col-xs-16">
          <div className="fake-void left"></div>
          <div className="fake-void right"></div>
          <div className="inner">
            <div className="row list-panel-row">
              {
                icons.map((icon, index) => (
                  <IconListPanelCol key={ index } icon={ icon } />
                ))
              }
            </div>
          </div>
          <div className="stroke vertical left"></div>
          <div className="stroke vertical right"></div>
        </div>
      </div>
    );
  }

};
